/* Kokochao V15 Alpha 1.8 — lightweight universe hub filter. */
class KcH15UniverseHub extends HTMLElement {
  connectedCallback() {
    if (this.dataset.ready === 'true') return;
    this.dataset.ready = 'true';
    const input = this.querySelector('[data-kc-universe-search]');
    const cards = [...this.querySelectorAll('[data-kc-universe-card]')];
    const count = this.querySelector('[data-kc-universe-count]');
    if (!input || !cards.length) return;
    const normalize = (value = '') => value.toLocaleLowerCase('fr').normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const apply = () => {
      const query = normalize(input.value.trim());
      let visible = 0;
      cards.forEach((card) => {
        const show = !query || normalize(card.dataset.search || '').includes(query);
        card.hidden = !show;
        if (show) visible += 1;
      });
      if (count) count.textContent = String(visible);
    };
    input.addEventListener('input', apply, { passive: true });
  }
}
if (!customElements.get('kc-h15-universe-hub')) customElements.define('kc-h15-universe-hub', KcH15UniverseHub);
